import { gql } from '@apollo/client';

const GET_AGGREGATE_PERCENTAGE_DATA = gql`
  query GetAggregatePercentageData(
    $orgUnitId: Int!
    $practiceAreaId: Int!
    $appraisalProgramYear: Int!
    $practiceGroupLevel: Int!
    $range: String!
    $isIndustry: Boolean!
  ) {
    aggregatePercentageData(
      orgUnitId: $orgUnitId
      practiceAreaId: $practiceAreaId
      appraisalProgramYear: $appraisalProgramYear
      practiceGroupLevel: $practiceGroupLevel
      range: $range
      isIndustry: $isIndustry
    ) {
      AppraisalId
      MddapOrgUnitId
      MddapOrgUnitName
      IsUserHasAccessOrgUnit
    }
  }
`;

export default GET_AGGREGATE_PERCENTAGE_DATA;
